import React from 'react'
import { Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MessagePlaceholderIcon = createIcon({
    viewBox: '0 0 80 80',
    path: (
        <>
            <Path
                fill='none'
                stroke='currentColor'
                strokeWidth={2}
                d='M7 7a4 4 0 0 0-4 4v61.492L17.688 57H73a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4H7z'
            />
            <Rect
                fill='none'
                stroke='currentColor'
                width={35}
                height={1}
                x={17.5}
                y={43.5}
                rx={0.5}
            />
            <Rect
                fill='none'
                stroke='currentColor'
                width={45}
                height={1}
                x={17.5}
                y={31.5}
                rx={0.5}
            />
            <Rect
                fill='none'
                stroke='currentColor'
                width={45}
                height={1}
                x={17.5}
                y={19.581}
                rx={0.5}
            />
        </>
    ),
})

MessagePlaceholderIcon.displayName = 'MessagePlaceholderIcon'
